<div class="search-suggester" [ngClass]="{ active: searchSuggestionsActive }">
  <form
    class="form-inline search-input-frm"
    [formGroup]="searchForm"
    #form="ngForm"
  >
    <div class="form-group search-group">
      <div class="search-input">
        <span class="search-icon">
          <fa-icon [icon]="['fas', 'arrow-right-to-bracket']"></fa-icon>
        </span>
        <input
          type="text"
          #searchInput
          class="form-control search-input"
          formControlName="query"
          [value]="searchQuery"
          (keyup)="onKeyUp(searchInput.value, $event)"
          (focus)="onFocus()"
          placeholder="{{
            'search-suggest.placeholder-suggest-feed-or-object' | translate
          }}"
        />
      </div>
    </div>
    <app-loading
      *ngIf="suggestionsLoading$ | async"
      [size]="'1x'"
    ></app-loading>
  </form>
  <div class="search-suggest">
    <div class="title" *ngIf="!recentObjectsMode">
      {{ "search-suggest.title.all-mathes" | translate }}
    </div>
    <div class="title" *ngIf="recentObjectsMode">
      {{ "search-suggest.title.recents" | translate }}
    </div>
    <div
      class="collections suggest-list"
      *ngIf="
        recentObjectsMode === false &&
        (!searchSuggestions || searchSuggestions.length == 0)
      "
    >
      <span>{{
        "search-suggest.title.no-objects-match-the-criteria" | translate
      }}</span>
    </div>
    <ul class="suggest-items">
      <ng-container *ngIf="searchSuggestions?.length; else noSuggestions">
        <li
          (click)="selectSuggestion(suggestion)"
          *ngFor="let suggestion of searchSuggestions; let i = index"
          class="suggest-item"
          [ngClass]="{ active: suggestion.active }"
        >
          <div class="suggest-item-title">
            <span class="icon">
              <fa-icon
                *ngIf="suggestion.icon"
                [icon]="suggestion.icon"
              ></fa-icon>
            </span>

            <span class="suggestion">
              <i class="fa fa-search"></i>
              <span
                [innerHTML]="suggestion.title | highlight: typedQuery"
              ></span>
            </span>
          </div>
          <div class="remove" *ngIf="recentObjectsMode">
            <fa-icon
              class="clear-icon"
              [icon]="['fas', 'times']"
              (click)="removeRecentObject($event, suggestion)"
            ></fa-icon>
          </div>
        </li>
      </ng-container>
    </ul>

    <!-- Template for empty state -->
    <ng-template #noSuggestions>
      <li class="suggest-item no-results">
        {{ "search-suggest.message.no-suggestions-found" | translate }}
      </li>
    </ng-template>
  </div>
</div>
